var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-mini/calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90002 2.8999C7.39708 2.8999 7.80002 3.30285 7.80002 3.7999V5.2999H16.2V3.7999C16.2 3.30285 16.603 2.8999 17.1 2.8999C17.5971 2.8999 18 3.30285 18 3.7999V5.2999H18.3C20.1226 5.2999 21.6 6.77736 21.6 8.5999V18.7999C21.6 20.6224 20.1226 22.0999 18.3 22.0999H5.70002C3.87749 22.0999 2.40002 20.6224 2.40002 18.7999V8.5999C2.40002 6.77736 3.87748 5.2999 5.70002 5.2999H6.00002V3.7999C6.00002 3.30285 6.40297 2.8999 6.90002 2.8999ZM5.70002 9.4999C4.8716 9.4999 4.20002 10.1715 4.20002 10.9999V18.7999C4.20002 19.6283 4.8716 20.2999 5.70003 20.2999H18.3C19.1285 20.2999 19.8 19.6283 19.8 18.7999V10.9999C19.8 10.1715 19.1285 9.4999 18.3 9.4999H5.70002Z",
    fill: "black",
    fillOpacity: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar2);
export default __webpack_public_path__ + "static/media/calendar 2.fb7b72d7621ffad9ddc290c96977bc44.svg";
export { ForwardRef as ReactComponent };